import { Button } from '@/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuLabel,
    DropdownMenuRadioGroup,
    DropdownMenuRadioItem,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useTranslations } from '@/i18n';
import { Globe } from 'lucide-react';

export function LanguageSwitcher({ compact = false }: { compact?: boolean }) {
    const { language, setLanguage, t, languageOptions } = useTranslations();

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    variant="ghost"
                    size={compact ? 'icon' : 'sm'}
                    className={compact ? 'h-9 w-9' : 'gap-2'}
                    aria-label={t('Language')}
                >
                    <Globe className="h-4 w-4" />
                    {!compact && (
                        <span className="text-sm font-medium">
                            {language.toUpperCase()}
                        </span>
                    )}
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="min-w-40">
                <DropdownMenuLabel>{t('Language')}</DropdownMenuLabel>
                <DropdownMenuRadioGroup
                    value={language}
                    onValueChange={(value) => {
                        setLanguage(value as typeof language);
                    }}
                >
                    {languageOptions.map((option) => (
                        <DropdownMenuRadioItem
                            key={option.value}
                            value={option.value}
                        >
                            {option.label}
                        </DropdownMenuRadioItem>
                    ))}
                </DropdownMenuRadioGroup>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
